// TODO: This session should be removed from the application ASAP

import { ISessionService } from '../../services/session';
import { initDeprecatedSessionSvc } from '../../clients/shell/session';
import { internalLogger } from '../../interface/v1/clientOsLogger';
import { ClientOSInterfacesType } from '@clientos/types/dist';

export type InitializeDeprecatedServicesType = {
  sessionService: ISessionService;
  orgSelector: ClientOSInterfacesType['v1']['orgSelector'];
  isNative: boolean;
};

export default class InitializeDeprecatedServices {
  public static async init({
    sessionService,
    orgSelector,
    isNative
  }: InitializeDeprecatedServicesType): Promise<void> {
    try {
      await initDeprecatedSessionSvc({ sessionService });
      if (sessionService?.isLoggedIn() && !isNative)
        await orgSelector?.updateDomainList();
    } catch (error) {
      /* istanbul ignore next */
      internalLogger?.error('Error initializing deprecated services:', error);
    }
  }
}
